import { CancelOrderUsecase, CancelOrderUsecaseImp } from 'domain/usecases/cancel-order-usecase';
import { makeCancelOrderHttpRepository } from '../repositories/http/orders-http-repository-factory';

export const makeCancelOrderUsecase = (): CancelOrderUsecase => {
  return new CancelOrderUsecaseImp(makeCancelOrderHttpRepository());
};
